/* eslint-disable react/no-danger */
/* eslint-disable react/static-property-placement */
import Space from 'Modules/Space/Space';
import PropTypes, { shape } from 'prop-types';
import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

const ConfirmModal = ({
  title,
  message,
  confirmButtonText,
  showModal,
  onClose,
  onSubmit,
  loading,
  error,
}) => {
  return (
    <Modal open={showModal} size="tiny" onClose={onClose} closeIcon>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content image>
        <div>{message}</div>
      </Modal.Content>
      <Modal.Actions>
        <Space direction="horizontal" justify="space-between" flexWrap="nowrap">
          <div style={{ color: 'red', textAlign: 'left' }}>
            {error?.data?.message || error?.message}
          </div>
          <Space direction="horizontal" justify="flex-end">
            <Button size="small" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button size="small" loading={loading} onClick={onSubmit} primary>
              {confirmButtonText}
            </Button>
          </Space>
        </Space>
      </Modal.Actions>
    </Modal>
  );
};

ConfirmModal.defaultProps = {
  error: {},
  confirmButtonText: 'Ok',
};
ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string,
  message: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.objectOf(shape({})),
};

export default ConfirmModal;
